import { useQuery } from "@tanstack/react-query";
import httpRequest from "app/lib/axios/index";

interface ApplicationServiceability {
  NetSurplusRatioExcludingAddbacks: number;
  MaxBorrowingAmount: number;
}

interface ServiceabilityResult {
  ApplicationServiceability: ApplicationServiceability;
}

interface ServiceabilityResponse {
  ServiceabilityResults: ServiceabilityResult[];
}

const fetchData = async (id: string): Promise<ServiceabilityResponse> => {
  const response = await httpRequest.get(
    `/loan-application/${id}/get-serviceability`
  );
  return response.data as ServiceabilityResponse;
};

export const useGetServiceability = (id: string) => {
  return useQuery<ServiceabilityResponse, Error>({
    queryKey: ["get-serviceability", id],
    queryFn: () => fetchData(id),
    enabled: false,
    gcTime: 0,
    retry: false,
  });
};
